import React from "react";
import '@fortawesome/free-regular-svg-icons'
import Chip from '@mui/material/Chip';
import '../assets/styles/Certificate.scss';

const certificates = [
    {
        title: "Claude Certified Architect - Foundations (CCAR-F)",
        issuer: "Anthropic",
        date: "08/2026",
        badge: "https://images.credly.com/size/340x340/images/f2040db3-3904-4240-8966-e87b1510bea0/blob",
        link: "https://www.credly.com/badges/b7529274-6481-4774-abaa-d2d141d57209",
        description: "Validates the foundational skills to design and ship production-grade AI solutions with Claude: agentic architecture, tool and MCP integration, Claude Code configuration, prompt engineering, and context management.",
        skills: ["Claude API", "Claude Agent SDK", "Claude Code", "MCP", "Prompt Engineering"]
    },
    {
        title: "Claude Certified Architect - Professional (CCAR-P)",
        issuer: "Anthropic",
        date: "09/2026",
        badge: "https://images.credly.com/size/340x340/images/7583afbc-4aab-4c7d-8af4-d9af72786ab3/blob",
        link: "https://www.credly.com/badges/7a59b7ca-737b-40ec-ac69-0a8750611947",
        description: "Validates the ability to design and lead enterprise-scale Claude deployments: integration architecture, context engineering, evaluation and optimization at scale, and AI governance with responsible deployment practices.",
        skills: ["Enterprise Architecture", "Integration Architecture", "Context Engineering", "AI Governance", "Evaluation & Optimization"]
    }
];

function Certificate() {
    return (
    <div className="certificates-container" id="certificate">
        <h1>Certificates</h1>
        <div className="certificates-grid">
            {certificates.map((certificate, index) => (
                <div className="certificate" key={index}>
                    <a href={certificate.link} target="_blank" rel="noreferrer">
                        <img src={certificate.badge} className="certificate-badge zoom" alt={`${certificate.title} badge`}/>
                    </a>
                    <div className="certificate-body">
                        <h2>
                            <a href={certificate.link} target="_blank" rel="noreferrer">{certificate.title}</a>
                        </h2>
                        <h4>{certificate.issuer} &middot; {certificate.date}</h4>
                        <p>{certificate.description}</p>
                        <div className="flex-chips">
                            {certificate.skills.map((skill, skillIndex) => (
                                <Chip key={skillIndex} className='chip' label={skill} />
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
    );
}

export default Certificate;
